// actions
import { DBDrop, LocalClear } from '@weblite/persist'
import { setTwaAuthToken, TWA_EVENTS } from '$logic/twaCommunication'
import { dispatchSetConnectionStatus } from '$comp/main/root.action'
import { DB_NAME } from '$setup/persist'
import { fullReload } from '$func/fullReload'
import { SessionStorageKeys } from '$logic/client-device/types'
import {
  sessionStorageGetItem,
  sessionStorageSetItem,
} from '$func/session-storage'
import { sendEventToTwa } from '$logic/twaCommunication/twaCommunication.api'
import { saveSignOutByServerAnalyticsEventToLocal } from '$logic/auth/sign-out-analytics'

export const restoreSessionStorageOnSignOut = () => {
  // retain `twaWsUrl` so that after login, client can send the new token to TWA
  const wsUrl = sessionStorageGetItem(SessionStorageKeys.TWA_WS_URL)
  // retain `contact_perm` so that after login, client can sync contacts to TWA
  const contactPerm = sessionStorageGetItem(SessionStorageKeys.CONTACT_PERM)
  // retain `isTwa` so that after login, client can work with TWA
  const isTwa = sessionStorageGetItem(SessionStorageKeys.IS_TWA)
  sessionStorage.clear()
  sessionStorageSetItem(SessionStorageKeys.TWA_WS_URL, wsUrl)
  sessionStorageSetItem(SessionStorageKeys.CONTACT_PERM, contactPerm)
  sessionStorageSetItem(SessionStorageKeys.IS_TWA, isTwa)
}

export default () => {
  sendEventToTwa(TWA_EVENTS.LOGOUT)
  dispatchSetConnectionStatus('signing out')
  LocalClear()
  restoreSessionStorageOnSignOut()
  setTwaAuthToken(null)
  saveSignOutByServerAnalyticsEventToLocal()
  DBDrop(DB_NAME).then(fullReload)
}
